import AppConstants from '../config/app.constants';

let AutomatedRoutingStopsService = function ($http, $q) {
    let assignAutomatedRoutes = (routeIds, vaultDate, branchId) => {
        return $http
            .post(AppConstants.api + `/automated-routing-control/assign-routes`, {
                   routes:routeIds, vaultDate, branchId
            })
            .then((res) => {
                return res.data
            })
    };
    let getRouteEstimatedReturnTimes = (routeIds, vaultDate) => {
        return $http
            .get(AppConstants.api + `/automated-routing-control/get-route-estimated-time`, {
                params: { routeIds: routeIds.join(','), date: vaultDate }
            })
            .then((res) => {
                return res.data
            })
    };
    return {
        assignAutomatedRoutes,
        getRouteEstimatedReturnTimes
    }
}
AutomatedRoutingStopsService.$inject = ['$http', '$q']

export default AutomatedRoutingStopsService;


// WEBPACK FOOTER //
// ./client/app/services/automated-routing-stops.service.js